import getWindow from '@loggi/js/get-window';
import View from '@loggi/ui/components/view';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import React from 'react';
import Covid19Message from '../../covid19-message/covid19-message.component';
import getLayout from '../../status/get-layout.service';
import getStatus from '../../status/get-status.service';
import getEtaStatusMessage from '../../status/status-eta-message.service';
import {
  GOING_TO_RECIPIENT,
  GOING_TO_RECIPIENT_WITH_RELATIVE_ETA
} from '../../status/status.constants';
import Card from '../card.component';
import styles from './status-card.component.scss';
import StatusMessage from '../../status/status-message-components';

export const STATUS_CARD_ID = 'status-card';

const featureSwitchCovid19MessageIsEnabled = () => {
  const _window = getWindow();
  return get(_window, 'loggi.bootstrapData.is_covid19_message_enabled', false);
};

export default function StatusCard({
  statusInfo,
  className,
  showEtaMessage,
  receivedBy,
  isOriginLoggiApp
}) {
  const {
    eta,
    shipperStatus,
    redispatchInfo: { trackingCode }
  } = statusInfo;
  const status = getStatus(statusInfo);
  const layout = getLayout(status);

  const { styleName } = layout;
  const isRedispatch = !!trackingCode;

  const statusStyle = styles[styleName];

  const isGoingToRecipient =
    status === GOING_TO_RECIPIENT ||
    status === GOING_TO_RECIPIENT_WITH_RELATIVE_ETA;

  return (
    <View data-testid={STATUS_CARD_ID}>
      {(shipperStatus || featureSwitchCovid19MessageIsEnabled()) && (
        <Card
          gutter="onehalf"
          className={`${styles.statusCard} ${className} ${statusStyle}`}
        >
          <StatusMessage shipperStatus={shipperStatus} />
          {featureSwitchCovid19MessageIsEnabled() && !isOriginLoggiApp && (
            <Covid19Message />
          )}
        </Card>
      )}

      {eta && showEtaMessage && !isGoingToRecipient && (
        <View
          className="eta-message"
          gutter={{ top: 'onehalf', bottom: 'onehalf' }}
        >
          {getEtaStatusMessage(eta, status, !isRedispatch ? receivedBy : null)}
        </View>
      )}
    </View>
  );
}

StatusCard.propTypes = {
  statusInfo: PropTypes.shape({
    firstName: PropTypes.string,
    companyName: PropTypes.string,
    eta: PropTypes.number,
    relativeEta: PropTypes.number,
    currentStatus: PropTypes.shape({
      error: PropTypes.number,
      inProgress: PropTypes.bool,
      destination: PropTypes.string
    }),
    shipperStatus: PropTypes.shape({
      code: PropTypes.number,
      label: PropTypes.string,
      description: PropTypes.string,
      actionRequired: PropTypes.shape({
        reasonLabel: PropTypes.string,
        reasonDescription: PropTypes.string
      })
    }),
    redispatchInfo: PropTypes.shape({
      trackingCode: PropTypes.string,
      maxPickupTime: PropTypes.number
    })
  }).isRequired,
  className: PropTypes.string,
  showEtaMessage: PropTypes.bool,
  receivedBy: PropTypes.string,
  isOriginLoggiApp: PropTypes.bool
};

StatusCard.defaultProps = {
  className: null,
  showEtaMessage: false,
  receivedBy: null,
  isOriginLoggiApp: false
};
